const resendEmail = {
  'Activá tu cuenta a través del email que te enviamos a ': 'Activá tu cuenta a través del email que te enviamos a ',
}

export default resendEmail
